// imports
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { ORGANIZATIONS, ORGANIZATION_STAT_CARDS, SUBCATEGORY_SECTIONS, ORGANIZATION_NDI_CARDS, WISHLISTS, ORGANIZATION_NI_CARDS } from '../../../Utilities/APIs'
import Image from '../../Partials/Elements/Image/Image'
import ImageTitleDescriptionSection from './ImageTitleDescriptionSection/ImageTitleDescriptionSection'
import OrganizationStatSection from './OrganizationStatSection/OrganizationStatSection'
import OrganizationBranches from './OrganizationBranches/OrganizationBranches'

import OrganizationContacts from './OrganizationContacts/OrganizationContacts'
import OrganizationSummary from './OrganizationSummary/OrganizationSummary'

import './OrganizationDetails.css'
import { useSelector } from 'react-redux'
import axios from 'axios'

function OrganizationDetails() {

    // states
    const { organizationId } = useParams()
    const [singleOrganization, setSingleOrganization] = useState(null)
    // console.log(singleOrganization)

    const [statCards, setStatCards] = useState(null)
    const [NDICards, setNDICards] = useState(null)
    const [NICards, setNICards] = useState(null)
    console.log(NICards)
    const [subcatSections, setSubcatSections] = useState(null)

    const [toggleFetch, setToggleFetch] = useState(false)

    const {consumer} = useSelector(state => state.auth)

    const navigate = useNavigate()

    // useEffects
    useEffect(() => {
        async function getAndSetSingleOrganization() {
            const orgRes = await fetch(ORGANIZATIONS + organizationId)
            let orgData = await orgRes.json()
            
            if (consumer) {
                const config = {
                    headers: {
                        Authorization: `Bearer ${consumer.token}`
                    }
                }
                const {data} = await axios.get(WISHLISTS + 'myWishlist', config)
                const wishData = data.map(d => d.organization)
                
                if (wishData.includes(orgData._id)) {
                    orgData = {...orgData, favorite: true}
                }
            }
            setSingleOrganization(orgData)
        }

        getAndSetSingleOrganization()
    }, [organizationId, consumer, toggleFetch])

    useEffect(() => {

        async function getAndSetCards() {
            const statRes = await fetch(ORGANIZATION_STAT_CARDS + 'getStatCardsFromOrganization/' + organizationId)
            const statData = await statRes.json()
            setStatCards(statData)

            const NDIRes = await fetch(ORGANIZATION_NDI_CARDS + 'getNDICardsFromOrganization/' + organizationId)
            const NDIData = await NDIRes.json()
            setNDICards(NDIData)


            const NIRes = await fetch(ORGANIZATION_NI_CARDS + 'getNICardsFromOrganization/' + organizationId)
            const NIData = await NIRes.json()
            setNICards(NIData)
        }

        getAndSetCards()

    }, [organizationId])

    // console.log(NIData)

    useEffect(() => {
        if (singleOrganization) {
            async function getAndSetSubcatSections() {
                const sectionRes = await fetch(SUBCATEGORY_SECTIONS + 'getSectionsFromSubcategory/' + singleOrganization.subcategory)
                const sectionData = await sectionRes.json()
                setSubcatSections(sectionData)
            }
            getAndSetSubcatSections()
        }
    }, [singleOrganization])

    async function handleFavorite() {
        if (consumer) {

            const config = {
                headers: {
                    Authorization: `Bearer ${consumer.token}`
                }
            }

            if (singleOrganization.favorite === true) {
                await axios.delete(WISHLISTS + singleOrganization._id, config)
            } else {
                await axios.post(WISHLISTS, {organization: singleOrganization._id}, config)
            }

            triggerFetch()

        } else {
            navigate('/login')
        }
    }

    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }

    return (
        <main className='org_details_page'>
            <div className="banner">
                {singleOrganization && <Image imgSrc={singleOrganization.coverImage} imgAlt={singleOrganization.name} />}
            </div>
            <div className="container">
                <div className="orgd_content">
                    <div className="row">
                        <OrganizationSummary 
                            singleOrganization={singleOrganization}
                            favorite={singleOrganization?.favorite}
                            handleClick={handleFavorite}
                            consumer={consumer}
                        />
                        <OrganizationContacts 
                            organizationId={organizationId}
                            consumer={consumer}
                        />
                    </div>
                </div>

                <OrganizationBranches organizationId={organizationId} />

                {/* {
                    subcatSections?.find(s => s.type === 'NI') && NDICards &&
                    <>
                        <h2>{subcatSections?.find(s => s.type === 'NI').name}</h2>
                        <ImageTitleDescriptionSection uniqueClass='ITD2' NDICards={NDICards} subcategory={singleOrganization?.subcategory} />
                    </>
                } */}

                {
                    subcatSections?.find(s => s.type === 'NDI') && NDICards &&
                    <>
                        <h2>{subcatSections?.find(s => s.type === 'NDI').name}</h2>
                        <ImageTitleDescriptionSection 
                        uniqueClass='NDI' 
                        ITDCards={NDICards} 
                        subcategory={singleOrganization?.subcategory}
                        hasDescription  
                        />
                    </>
                }

                {
                    subcatSections?.find(s => s.type === 'NI') && NDICards &&
                    <>
                        <h2>{subcatSections?.find(s => s.type === 'NI').name}</h2>
                        <ImageTitleDescriptionSection 
                        uniqueClass='NI' 
                        ITDCards={NICards} 
                        subcategory={singleOrganization?.subcategory}
                        />
                    </>
                }
                

                {
                    subcatSections?.find(s => s.type === 'stat') && statCards &&
                    <>
                        <h2>{subcatSections.find(s => s.type === 'stat').name}</h2>
                        <OrganizationStatSection statCards={statCards} subcategory={singleOrganization?.subcategory} />
                    </>
                }
                
            </div>
        </main>
    )
}

export default OrganizationDetails